import {HeaderMenuItem} from './header-menu-item';

export class HeaderMenuSeparator implements HeaderMenuItem {
  icon: any;
  title: any;
  url: any;
}
